module.exports = __webpack_public_path__ + "img/qinfo2.7570c6c4.webp";